import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import getYoutubeID from 'get-youtube-id';
import s from './YoutubeVideo.css';

class YoutubeVideo extends React.Component {
  static propTypes = {
    link: PropTypes.string,
    className: PropTypes.string.isRequired,
  };
  static defaultProps = {
    link: null,
    className: '',
  };

  render() {
    const { link, className } = this.props;

    if (!link) {
      return null;
    }

    const id = getYoutubeID(link);

    if (!id) {
      return null;
    }

    return (
      <div className={cx(s.root, className)}>
        <iframe
          className={s.iframe}
          title="Youtube video"
          src={`https://www.youtube.com/embed/${id}`}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </div>
    );
  }
}

export default withStyles(s)(YoutubeVideo);



// WEBPACK FOOTER //
// ./src/shared/components/YoutubeVideo/YoutubeVideo.js